export default __webpack_public_path__ + "static/media/S2bless.2771d44e.mp4";